import Loader from "../../../../utility/loader";

export const STEPS = {
    CONNECT: 'connect',
    IMPORT: 'import',
}

export default class Model {
    constructor(selectedCompanyId) {
        this.currentStep = null
        this.importSessionId = null
        this.agreementToken = null
        this.selectedCompanyId = selectedCompanyId
        this.loader = new Loader()
    }

    setImportReady(importSessionId) {
        this.importSessionId = importSessionId
    }

    showConnect() {
        this.currentStep = STEPS.CONNECT
    }

    startImport() {
        this.loader.setForceLoading(true)
    }

    importAgain() {
        this.currentStep = STEPS.IMPORT
    }

    setAgreementToken(value) {
        this.agreementToken = value
    }

    setImportSessionId(value) {
        this.importSessionId = value
    }

    getStep() {
        return this.currentStep
    }

    getImportSessionId() {
        return this.importSessionId
    }

    getAgreementToken() {
        return this.agreementToken
    }

    getSelectedCompanyId() {
        return this.selectedCompanyId
    }

    isLoading() {
        return this.loader.isLoading
    }
}